<template>
  <v-dialog v-model="show" persistent max-width="500px">
    <v-card>
      <v-toolbar color="primaryLight" dark dense>
        <v-toolbar-title>{{ accionDialog }}</v-toolbar-title>
      </v-toolbar>

      <v-card-text>
        <v-form ref="form" v-model="isValid">
          <v-container>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="nombre"
                  label="Nombre de usuario"
                  :rules="[rules.required]"
                  outlined
                  dense
                />
              </v-col>

              <v-col>
                <v-text-field
                  v-model="password"
                  label="Contraseña"
                  type="password"
                  :rules="[rules.required]"
                  outlined
                  dense
                />
              </v-col>
              <v-col v-if="!isEdit">
                <v-text-field
                  v-model="confirmPassword"
                  label="Confirmar contraseña"
                  type="password"
                  :rules="[rules.passwordMatch]"
                  outlined
                  dense
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-select
                  v-model="rolSeleccionado"
                  label="Rol"
                  :items="roles"
                  item-text="ROL"
                  item-value="ID_ROL"
                  return-object
                  outlined
                  dense
                />
              </v-col>

              <v-col>
                <v-select
                  v-model="medioSeleccionado"
                  label="Medio"
                  :items="medios"
                  item-text="MEDIO"
                  item-value="ID_MEDIO"
                  return-object
                  outlined
                  dense
                />
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn text color="red" @click="cancelar">Cancelar</v-btn>
        <v-btn text color="green" :disabled="!isValid" @click="aceptar">Aceptar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    show: Boolean,
    isEdit: Boolean,
    editedUsuario: Object
  },

  data () {
    return {
      isValid: false,
      nombre: '',
      password: '',
      confirmPassword: '',
      rolSeleccionado: null,
      medioSeleccionado: null,
      rules: {
        required: v => !!v || 'Campo requerido',
        passwordMatch: v => !!v || this.password === this.v || 'Las contraseñas no coinciden'
      }
    }
  },

  computed: {
    ...mapGetters('usuario', ['roles']),
    ...mapGetters('medio', ['medios']),
    accionDialog () {
      return this.isEdit ? 'Editar usuario' : 'Nuevo usuario'
    }
  },

  watch: {
    show () {
      if (this.show) {
        if (this.isEdit && this.editedUsuario) {
          this.nombre = this.editedUsuario.USUARIO
          this.password = this.editedUsuario.PASSWD || ''
          this.rolSeleccionado = this.roles.find(r => r.ID_ROL === this.editedUsuario.ROL.ID_ROL)
          this.medioSeleccionado = this.medios.find(m => m.ID_MEDIO === this.editedUsuario.ID_MEDIO)
        } else {
          this.resetForm()
        }
      }
    }
  },

  methods: {
    aceptar () {
      const isFormValid = this.$refs.form.validate()
      if (!isFormValid) return

      const nuevoUsuario = {
        USUARIO: this.nombre.trim(),
        PASSWD: this.password,
        ID_ROL: this.rolSeleccionado?.ID_ROL,
        ID_MEDIO: this.medioSeleccionado?.ID_MEDIO || null
      }

      if (this.isEdit && this.editedUsuario?.ID_USUARIO) {
        const usuarioConId = {
          ...nuevoUsuario,
          ID_USUARIO: this.editedUsuario?.ID_USUARIO
        }
        this.$emit('editUsuario', usuarioConId)
      } else {
        this.$emit('addUsuario', nuevoUsuario)
      }

      this.resetForm()
      this.$emit('update:show', false)
    },

    cancelar () {
      this.resetForm()
      this.$emit('cancelar')
      this.$emit('update:show', false)
    },

    resetForm () {
      this.nombre = ''
      this.password = ''
      this.rolSeleccionado = null
      this.medioSeleccionado = null
      this.$refs.form?.reset()
    }
  }

}
</script>

<style scoped>
</style>
